var React = require('react');

function BackendDropdownMenuIpReports (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000000","d":"M16 14v-6h-4v-4h-4v-3h-8v6h3v1h-1v1h4v-1h-1v-1h3v-2h3v3h-3v6h3v1h-1v1h4v-1h-1v-1h3zM7 6h-6v-4h6v4zM9 13v-4h6v4h-6z"}));
}

BackendDropdownMenuIpReports.displayName = "BackendDropdownMenuIpReports";

BackendDropdownMenuIpReports.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = BackendDropdownMenuIpReports;

BackendDropdownMenuIpReports.default = BackendDropdownMenuIpReports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/backend-dropdown-menu-ip-reports.svg
// module id = 1001
// module chunks = 0